<template>
  <div>
    <!-- SITUAÇÃO DOS USUÁRIOS: CONTAGEM + FILTRO (VISÍVEL PARA TODOS) -->
    <div class="row mb-2">
      <div class="col-12">
        <div class="btn-group btn-group-sm" role="group" aria-label="Filtrar por situação">
          <button type="button" class="btn" :class="situacao == '1' ? 'btn-success' : 'btn-outline-success'" @click="situacao = '1'">
            <i class="fas fa-user-check"></i> Ativos ({{ totalAtivos }})
          </button>
          <button type="button" class="btn" :class="situacao == '0' ? 'btn-secondary' : 'btn-outline-secondary'" @click="situacao = '0'">
            <i class="fas fa-user-slash"></i> Inativos ({{ totalInativos }})
          </button>
          <button type="button" class="btn" :class="situacao == '' ? 'btn-primary' : 'btn-outline-primary'" @click="situacao = ''">
            <i class="fas fa-users"></i> Todos ({{ usuarios.length }})
          </button>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="row" v-if="podeAlterarFilas">
      <div class="col-md-4 mb-2">
        <input type="text" class="form-control" placeholder="Buscar por nome, login ou ramal" v-model="busca" />
      </div>
      <div class="col-md-3 mb-2">
        <select class="form-control" v-model="tipo">
          <option value="">Todos os tipos</option>
          <option value="1">Supervisor</option>
          <option value="2">Operador</option>
        </select>
      </div>
      <div class="col-md-3 mb-2">
        <select class="form-control" v-model="filaFiltro">
          <option value="">Todas as filas</option>
          <option v-for="fila in filas" :key="fila.id" :value="String(fila.id)">{{ fila.alias ? fila.alias : fila.name }}</option>
        </select>
      </div>
      <div class="col-md-2 mb-2 d-flex align-items-center">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="selecionarFiltrados" :checked="todosFiltradosSelecionados" :disabled="filtrados.length == 0" @change="alternarFiltrados" />
          <label class="custom-control-label" for="selecionarFiltrados">Selecionar todos ({{ filtrados.length }})</label>
        </div>
      </div>
      <div class="col-12">
        <small class="text-muted">Clique no card para selecionar; Shift+clique marca um intervalo.</small>
        <small class="text-danger ml-2" v-if="erroLogados">{{ erroLogados }}</small>
        <button type="button" class="btn btn-outline-secondary btn-sm float-right" @click="abrirAgendamentos"><i class="fas fa-clock"></i> Agendamentos de filas</button>
      </div>
    </div>

    <div class="row">
      <users2-box-component
        v-for="usuario in filtrados"
        :key="usuario.id"
        :data="usuario"
        :selecionavel="podeAlterarFilas"
        :selecionado="selecionados.includes(usuario.id)"
        :logado="logados[usuario.id] || null"
        @alternar="alternar"
      ></users2-box-component>
      <div class="col-12 text-center text-muted mt-3" v-if="carregado && filtrados.length == 0">Nenhum usuário encontrado.</div>
    </div>

    <!-- BARRA DE AÇÕES (4.2) -->
    <div class="barra-lote" v-if="selecionados.length > 0">
      <span class="mr-3"><strong>{{ selecionados.length }}</strong> {{ selecionados.length == 1 ? 'usuário selecionado' : 'usuários selecionados' }}</span>
      <button type="button" class="btn btn-primary btn-sm mr-2" @click="abrirModal"><i class="fas fa-random"></i> Alterar filas</button>
      <button type="button" class="btn btn-outline-light btn-sm" @click="limparSelecao">Limpar seleção</button>
    </div>

    <modal-filas-lote
      v-if="podeAlterarFilas"
      ref="modalLote"
      :usuarios="usuariosSelecionados"
      :filas="filas"
      :url-historico="urlHistorico"
      @concluido="aoConcluir"
      @logados="atualizarLogados"
    ></modal-filas-lote>
  </div>
</template>

<script>
import ModalFilasLote from './ModalFilasLote.vue';

export default {
  components: { ModalFilasLote },
  props: {
    podeAlterarFilas: { type: Boolean, default: false },
    urlHistorico: { type: String, default: '/user_queues/historico' },
  },
  data() {
    return {
      usuarios: [],
      filas: [],
      logados: {},
      selecionados: [],
      ultimoClicado: null,
      busca: '',
      tipo: '',
      filaFiltro: '',
      situacao: '',
      carregado: false,
      erroLogados: '',
    };
  },
  computed: {
    filtrados() {
      const termo = this.busca.trim().toLowerCase();
      return this.usuarios.filter(u => {
        if (termo) {
          const texto = `${u.name || ''} ${u.login || ''} ${u.extension_line || ''}`.toLowerCase();
          if (!texto.includes(termo)) return false;
        }
        if (this.tipo && String(u.active) !== this.tipo) return false;
        if (this.situacao && this.situacaoDe(u) !== this.situacao) return false;
        if (this.filaFiltro && !(u.queue || []).map(String).includes(this.filaFiltro)) return false;
        return true;
      });
    },
    totalAtivos() {
      return this.usuarios.filter(u => this.situacaoDe(u) === '1').length;
    },
    totalInativos() {
      return this.usuarios.filter(u => this.situacaoDe(u) === '0').length;
    },
    todosFiltradosSelecionados() {
      return this.filtrados.length > 0 && this.filtrados.every(u => this.selecionados.includes(u.id));
    },
    usuariosSelecionados() {
      return this.usuarios.filter(u => this.selecionados.includes(u.id));
    },
  },
  mounted() {
    this.carregar();
    // user.js CHAMA ESTE EVENTO DEPOIS DE CRIAR/EDITAR/EXCLUIR
    window.addEventListener('usuarios:recarregar', this.carregar);
  },
  beforeDestroy() {
    window.removeEventListener('usuarios:recarregar', this.carregar);
  },
  methods: {
    // at_users.situacao: 1 = ATIVO, 0 = INATIVO (SEM A COLUNA, CONSIDERA ATIVO)
    situacaoDe(u) {
      return u.situacao !== undefined && u.situacao !== null && Number(u.situacao) === 0 ? '0' : '1';
    },
    carregar() {
      axios.get('/user/list')
        .then(response => {
          this.usuarios = Array.isArray(response.data) ? response.data : [];
          const ids = this.usuarios.map(u => u.id);
          this.selecionados = this.selecionados.filter(id => ids.includes(id));
          this.carregado = true;
          this.consultarLogados();
        })
        .catch(error => { console.error(error); });

      if (this.podeAlterarFilas && this.filas.length == 0) {
        axios.get('/user/listQueue')
          .then(response => { this.filas = response.data || []; })
          .catch(error => { console.error(error); });
      }
    },
    // INDICADOR DE LOGIN NO CARD (4.1) - SÓ INFORMATIVO
    consultarLogados() {
      if (!this.podeAlterarFilas || this.usuarios.length == 0) return;
      axios.post('/user_queues/logados', { usuarios: this.usuarios.map(u => u.id) })
        .then(response => {
          this.erroLogados = '';
          this.atualizarLogados(response.data.operadores || []);
        })
        .catch(error => {
          console.error(error);
          this.erroLogados = 'Não foi possível consultar quem está logado no PABX.';
        });
    },
    atualizarLogados(operadores, parcial = false) {
      const mapa = parcial ? Object.assign({}, this.logados) : {};
      if (parcial) this.selecionados.forEach(id => { delete mapa[id]; });
      operadores.forEach(op => { mapa[op.id] = op; });
      this.logados = mapa;
    },
    alternar({ id, shift }) {
      const lista = this.filtrados.map(u => u.id);
      const indice = lista.indexOf(id);
      const marcar = !this.selecionados.includes(id);

      let ids = [id];
      if (shift && this.ultimoClicado !== null && lista.includes(this.ultimoClicado)) {
        const inicio = Math.min(indice, lista.indexOf(this.ultimoClicado));
        const fim = Math.max(indice, lista.indexOf(this.ultimoClicado));
        ids = lista.slice(inicio, fim + 1);
      }

      this.definirSelecao(ids, marcar);
      this.ultimoClicado = id;
    },
    // MARCA TODOS OS RESULTADOS DO FILTRO, NÃO SÓ OS VISÍVEIS NA TELA
    alternarFiltrados() {
      this.definirSelecao(this.filtrados.map(u => u.id), !this.todosFiltradosSelecionados);
    },
    definirSelecao(ids, marcar) {
      if (marcar) {
        this.selecionados = Array.from(new Set(this.selecionados.concat(ids)));
      } else {
        this.selecionados = this.selecionados.filter(id => !ids.includes(id));
      }
    },
    limparSelecao() {
      this.selecionados = [];
      this.ultimoClicado = null;
    },
    abrirModal() {
      this.$refs.modalLote.abrir();
    },
    abrirAgendamentos() {
      this.$refs.modalLote.abrir('agendados');
    },
    aoConcluir() {
      this.limparSelecao();
      this.carregar();
    },
  },
};
</script>

<style scoped>
.barra-lote {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1030;
  padding: 12px 16px;
  background: #343a40;
  color: #fff;
  text-align: center;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.2);
}
</style>
